// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"MM-z","smallCardRow":"NM-z","largeCardRow":"OM-z","productSearchRow":"PM-z","curatedRow":"QM-z"};